import { useCallback, useEffect, useRef } from 'react';
import { useSpring, animated, to } from '@react-spring/web';
import { Annotation as VisxAnnotation, EditableAnnotation as VisxEditableAnnotation } from '@visx/annotation';
import BaseAnnotation from "./private/BaseAnnotation.js";
import { jsx as _jsx } from "react/jsx-runtime";
function BaseAnimatedAnnotation(_ref) {
  let {
    x = 0,
    y = 0,
    AnnotationComponent,
    ...props
  } = _ref;
  const lastXY = useRef({
    x,
    y
  });

  // in order to keep x/y/dx/dy accurate in AnnotationComponent, animate the delta
  // between positions, to an x + y transform of zero from the previous value
  const animatedXY = useSpring({
    from: {
      x: lastXY.current.x - x,
      y: lastXY.current.y - y
    },
    to: {
      x: 0,
      y: 0
    },
    reset: true
  });
  useEffect(() => {
    lastXY.current = {
      x,
      y
    };
  }, [x, y]);
  return /*#__PURE__*/_jsx(animated.g, {
    // for perf animate a group element not the Annotation itself
    transform: to([animatedXY.x, animatedXY.y], (xVal, yVal) => `translate(${xVal}, ${yVal})`),
    children: /*#__PURE__*/_jsx(AnnotationComponent, {
      x: x,
      y: y,
      ...props
    })
  });
}
export default function AnimatedAnnotation(_ref2) {
  let {
    editable,
    ...props
  } = _ref2;
  const AnnotationComponent = useCallback(annotationProps => /*#__PURE__*/_jsx(BaseAnimatedAnnotation, {
    AnnotationComponent: editable ? VisxEditableAnnotation : VisxAnnotation,
    ...annotationProps
  }), [editable]);
  return /*#__PURE__*/_jsx(BaseAnnotation, {
    AnnotationComponent: AnnotationComponent,
    ...props
  });
}